export default {
  'processes.title': 'Mis Procesos',
  'processes.newProcess': 'Nuevo Proceso',
  'processes.cloning': 'Clonando',
  'processes.editing': 'Editando',
  'processes.creating': 'Creando',
  'processes.process': 'Proceso',
  'processes.name': 'Nombre',
  'processes.userGroups': 'Grupos de usuarios',
  'processes.icon': 'Icono',
  'processes.color': 'Color',
  'processes.embedLink': 'Enlace de incorporación',
  'processes.kanban': 'Kanban',
  'processes.list': 'Lista',
  'processes.dashboard': 'Dashboard',
  'processes.table.code': 'Código',
  'processes.table.responsible': 'Responsable',
  'processes.table.destination': 'Destino',
  'processes.table.scheduling': 'Programación',
  'processes.table.completion': 'Finalización',
  'processes.table.status': 'Estado',
  'processes.table.priority': 'Prioridad',
  'processes.table.openedAt': 'Abierto en',
  'processes.actionPlans.showMore': 'Mostrar otros {count} planes de acción',
  'processes.search.normal': 'Búsqueda normal',
  'processes.search.byReply': 'Búsqueda por respuesta',
  'processes.search.byAdditionalField': 'Búsqueda por campo adicional',
  'processes.search.byDestination': 'Búsqueda por destino',
  'processes.error.createActivity': 'Error inesperado al crear actividad',
  'processes.dates.title': 'Fechas',
  'processes.dates.opening': 'Apertura',
  'processes.dates.scheduling': 'Programación',
  'processes.dates.completion': 'Finalización',
  'processes.dates.multiple': '{count} fechas',
  'processes.validation.required': 'Campo obligatorio',
  'processes.validation.invalidUrl': 'URL inválida',
  'processes.remove.confirm': '¿Está seguro de que desea eliminar?',
  'processes.remove.success': '¡Proceso eliminado con éxito!',
  'processes.remove.error': '¡Ocurrió un error al eliminar!',
  'processes.kanban.addColumn': 'Agregar Columna',
  'processes.welcome': '¡Bienvenido, {name}!',
  'processes.welcomeMessage': 'Vea lo que tenemos preparado para usted hoy.'
}
